import React, {useState} from "react";
import {Pressable, SafeAreaView, ScrollView, StyleSheet, Text, View} from "react-native";
import {useDispatch} from "react-redux";
import '../function/i18n';
import {useTranslation} from 'react-i18next';
import {AsyncDispatch} from "../function/functions";
import {FontAwesome} from "@expo/vector-icons";
import {useTheme} from "@react-navigation/native";
import { useMediaQuery } from "react-responsive";

export const MatrixScreen = ({route}) => {
    const {t} = useTranslation();
    const {task} = route.params;
    const theme = useTheme();
    const dispatch = useDispatch();
    const [matrix, setMatrix] = useState(task.matrix ?? 0);
    const isMobileWidth = useMediaQuery({
        maxDeviceWidth: 1224
    });
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            backgroundColor: theme.colors.scheme[3],
            flexWrap: 'nowrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        list: {
            flexGrow:1,
            display:'flex',
            flexDirection:'row',
            flexWrap:'wrap',
            padding:8
        },
        typeWrapper: {
            width:'100%',
            padding:4,
            borderRadius:27,
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
            marginBottom:8,
        },
        type: {
            width:'100%',
            height:48,
            paddingHorizontal:8,
            borderRadius:27,
            backgroundColor: theme.colors.scheme[4],
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
            borderWidth:2,
            borderColor:theme.colors.scheme[5]
        },
        check: {
            width:32,
            height:32,
            borderRadius:48,
            backgroundColor:theme.colors.scheme[4],
            borderColor: theme.colors.scheme[6],
            borderWidth:2,
            display:'flex',
            alignItems:'center',
            justifyContent:'center'
        },
        icon:{
            fontSize:16,
            color:'#fff'
        },
        text: {
            flexGrow:1,
            textAlign:'center',
            fontFamily:'Roboto-Light',
            color: theme.colors.scheme[2],
        },
        option1: {
            backgroundColor:'#f00',
            borderWidth:0
        },
        option2: {
            backgroundColor:'#ff7300',
            borderWidth:0
        },
        option3: {
            backgroundColor:'#fff200',
            borderWidth:0
        },
        option4: {
            backgroundColor:'#48ff00',
            borderWidth:0
        },
        option5: {
            backgroundColor:'#121212',
            borderWidth:0
        }
    });
    return(
        <SafeAreaView style={styles.container}>
            <ScrollView contentContainerStyle={{width:'100%'}}>
                <View style={styles.list}>
                    <View style={styles.typeWrapper}>
                        <Pressable onPress={() => {
                            setMatrix(1);
                            AsyncDispatch(dispatch, "EDIT_TASK", {id: task.id, data: {matrix: 1}}).then(() => {
                                dispatch({type: 'SAVE_TASK', payload: []});
                                //navigation.navigate('Home');
                            })
                        }
                        } style={({ pressed }) => [styles.type, {opacity: (pressed ? 0.5 : 1)}]}>
                            <View style={[styles.check, (matrix === 1 ? styles.option1 : null)]}></View>
                            <Text style={styles.text}>{t('matrix.option.1')}</Text>
                        </Pressable>
                    </View>
                    <View style={styles.typeWrapper}>
                        <Pressable onPress={() => {
                            setMatrix(2);
                            AsyncDispatch(dispatch, "EDIT_TASK", {id: task.id, data: {matrix: 2}}).then(() => {
                                dispatch({type: 'SAVE_TASK', payload: []});
                                //navigation.navigate('Home');
                            })
                        }
                        } style={({pressed}) => [styles.type, {opacity: (pressed ? 0.5 : 1)}]}>
                            <View style={[styles.check, (matrix === 2 ? styles.option2 : null)]}></View>
                            <Text style={styles.text}>{t('matrix.option.2')}</Text>
                        </Pressable>
                    </View>
                    <View style={{width:'100%'}}></View>
                    <View style={styles.typeWrapper}>
                        <Pressable onPress={() => {
                            setMatrix(3);
                            AsyncDispatch(dispatch, "EDIT_TASK", {id: task.id, data: {matrix: 3}}).then(() => {
                                dispatch({type: 'SAVE_TASK', payload: []});
                                //navigation.navigate('Home');
                            })
                        }
                        } style={({pressed}) => [styles.type, {opacity: (pressed ? 0.5 : 1)}]}>
                            <View style={[styles.check, (matrix === 3 ? styles.option3 : null)]}></View>
                            <Text style={styles.text}>{t('matrix.option.3')}</Text>
                        </Pressable>
                    </View>
                    <View style={styles.typeWrapper}>
                        <Pressable onPress={() => {
                            setMatrix(4);
                            AsyncDispatch(dispatch, "EDIT_TASK", {id: task.id, data: {matrix: 4}}).then(() => {
                                dispatch({type: 'SAVE_TASK', payload: []});
                                //navigation.navigate('Home');
                            })
                        }
                        } style={({pressed}) => [styles.type, {opacity: (pressed ? 0.5 : 1)}]}>
                            <View style={[styles.check, (matrix === 4 ? styles.option4 : null)]}></View>
                            <Text style={styles.text}>{t('matrix.option.4')}</Text>
                        </Pressable>
                    </View>
                    <View style={[styles.typeWrapper, {width:'100%'}]}>
                        <Pressable onPress={() => {
                            setMatrix(0);
                            AsyncDispatch(dispatch, "EDIT_TASK", {id: task.id, data: {matrix: 0}}).then(() => {
                            dispatch({type: 'SAVE_TASK', payload: []});
                            //navigation.navigate('Home');
                        })
                    }
                    } style={({pressed}) => [styles.type, {width:'100%', opacity: (pressed ? 0.5 : 1)}]}>
                            <View style={[styles.check, (matrix === 0 ? styles.option5 : null)]}></View>
                            <Text style={styles.text}>{t('matrix.option.5')}</Text>
                        </Pressable>
                    </View>
                </View>
            </ScrollView>
        </SafeAreaView>
    )
}